import React from "react";
import {useState, useEffect} from 'react';
import api from '../../../config.js';
import { checkWhichIconMustToBeReturned, getListFromFlow, getParameter, getPermission, getTableElementsWidthByLength, showMessageError } from '../../../classes/functions';
import './requests.css';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import { FaPen, FaEye, FaCog, FaSearch } from 'react-icons/fa';
import ReactTooltip from "react-tooltip";
import './requests.css';
import { Link, useLocation } from 'react-router-dom';
import ModalStatus from "../../../components/Modal/ModalStatus/index.js";
import TablePagination from "../../../components/TablePagination/index.js";
import { format } from "date-fns";
import axios from "axios";
import StatusButton from "../../../components/StatusButton/index.js";
import Select from "react-select";

export default function EPIRequests(){
  const [list, setList] = useState([]);
  const [modalStatus, setModalStatus] = useState(false);
  const [showSelectStatus, setShowSelectStatus] = useState(false);
  const [termSearch, setTermSearch] = useState('');
  const [carrying, setCarrying] = useState(true);
  const [cancelToken, setCancelToken] = useState(null);
  const [importCarrying, setImportCarrying] = useState(false);
  const [listStatus, setListStatus] = useState([]);
  const [listChangeStatus, setListChangeStatus] = useState([]);
  const [listItemsForApproval, setListItemsForApproval] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [statusButtonWasClicked, setStatusButtonWasClicked] = useState(false);
  const [itemChange, setItemChange] = useState({});
  const [novo_status, setNovoStatus] = useState('');
  const [pesquisa_status, setPesquisaStatus] = useState('');
  const [warehouses, setWarehouses] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState("");
  const [excel, setExcel] = useState('');
  const [dateOfExcel, setDateOfExcel] = useState('');
  const [qtdePage, setQtdePage] = useState(50);
  const [limitPage, setLimitPage] = useState(1);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState();
  const [typeSearch, setTypeSearch] = useState('');
  const timeToRefreshRequestList = getParameter("TEMPO_ATU_REQ");
  const location = useLocation();

  const selectStyle = {
    control: (styles) => ({...styles, backgroundColor: "white", border: "1px solid rgb(118, 118, 118)", borderRadius: "5px", height: "100%"}),
    input: (styles) => ({...styles, color: "black"}),
    placeholder: (styles) => ({...styles, color: "black"}),
  }

  useEffect(()=> {
    getRequests();
    
    api.get("/api/generics/getItens?table=7Y")
    .then((response) => {
      setListStatus(response.data);
    }).catch((error) => {
      showMessageError(error.response.data);
    });

    return () => {

    }
  }, []);
  
  let delay;
  function getRequests() {
    const newCancelToken = axios.CancelToken.source();
    setCancelToken(newCancelToken);
    clearTimeout(delay);
    
    delay = setTimeout(() => {  
      let data = {
        data: {
          termSearch: termSearch,
          status: selectedStatus || window.location?.href?.split("?status=")[1],
          page: page,
          qtdePage: qtdePage,
          itens: typeSearch
        }
      };

      if(selectedWarehouse){
        data.data.armazem = selectedWarehouse;
      }
  
      api.post("/api/product_requests/getSearch", data, {headers: {empresa: localStorage.empresa}}, {
        cancelToken: newCancelToken.token
      })
      .then((response) => {
        if(!newCancelToken.token.reason){
          setList(response.data.dados);
          setTotal(response.data.qtde);
          setLastPage(response.data.qtde, qtdePage);
          setLimitPage(parseInt(response.data.qtde / qtdePage) + 1);
        }

        setStatusButtonWasClicked(false);
        setShowSelectStatus(false);

          setCarrying(false);
        }
      ).catch((error) => {
        if(!axios.isCancel(error)){
          console.log(error?.message);
        } else{
          showMessageError(error.response.data);
        }
        
        setCarrying(false);
      });
    }, 750);
  }

  function setLastPage(aux_qtde, aux_qtdePage) {
    let lastPageIndex = parseInt(aux_qtde / aux_qtdePage);

    if ((aux_qtde % aux_qtdePage) > 0) {
      setLimitPage(lastPageIndex + 1);
    } else {
      setLimitPage(lastPageIndex);
    }
  }
  
  function openModalToEvaluate(item) {
    setItemChange(() => item);
    setListChangeStatus(getListFromFlow(item.fluxo, listStatus));
    
    api.get("/api/product_requests/getItemsForApproval?id=" + item.id)
      .then((response) => {
        setListItemsForApproval(response.data.list);
        setModalStatus(true);
      }).catch((error) => {
      showMessageError(error.response.data);
    });
  }

  function searchWarehouse(){
    if(!selectedWarehouse){
      api
      .get(`/api/warehouses/getSearchWarehouses?term=${selectedWarehouse?.toLowerCase()}`)
      .then((response) => {
        setWarehouses(response.data.list.map((warehouse) => {
          return {value: warehouse.id, label: warehouse.descricao};
        }));
      })
      .catch((error) => {
        showMessageError(error.response.data);
      });
    }
  }
   
  function changeStatus() {
    if (novo_status && novo_status != '') {
      let data = {
        data: {
          termSearch: termSearch,
          page: 1,
          qtdePage: qtdePage,
          status: novo_status,
          id: itemChange.id,
          items: listItemsForApproval
        }
      };

      let typeOfStatus;

      if(novo_status == "002"){
        typeOfStatus = "aprovar";
      } else if(novo_status == "003"){
        typeOfStatus = "negar";
      }
  
      //API original: `/api/product_requests/changeStatus?id=${itemChange.id}`
      //API para o futuro: `/api/products_requests/${itemChange.id}/${typeOfStatus}`
  
      api.put(`/api/products_requests/${itemChange.id}/${typeOfStatus}`, data)
      .then((response) => {
        setModalStatus(false);
        getRequests();

        toast.success("Aprovação realizada com sucesso.");
      })
      .catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    } else {
      toast.error('Selecione um status.');    
    }
  }

  function postExcel(event) {
    const file = event.target.files[0];

    const fileReader = new FileReader();
      
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      const dateAndHour = new Date();
      const formatedDateAndHour = format(dateAndHour, 'dd/MM/yyyy HH:mm:ss');

      setDateOfExcel(formatedDateAndHour);
      setExcel(fileReader.result.split('base64,')[1]);
    };
 
    fileReader.onerror = (error) => {
      console.log(error);
    }
  }

  useEffect(() => {
    if(excel){
      setImportCarrying(true);
      api
      .post('/api/request/xmls', {fileData: excel})
      .then((response) => {
        setImportCarrying(false);
        const a = document.createElement('a');
        a.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${response?.data?.fileData}`;
        a.download = `solicitacao ${dateOfExcel}.xlsx`;
        
        a.click();

        URL.revokeObjectURL(excel);

        setExcel("");

        getRequests();
      })
      .catch((error) => {
        setImportCarrying(false);
        showMessageError(error.response.data);
        console.log(error);
      });
    }
  }, [excel]);

  useEffect(() => {
    if(location?.state?.status){
      setPesquisaStatus(location?.state?.status);
    }
    
    getRequests();
  }, [qtdePage, termSearch, pesquisa_status, typeSearch, selectedWarehouse]);

  useEffect(() => {
    if(statusButtonWasClicked){
      getRequests();
    }
  }, [statusButtonWasClicked]);

  useEffect(() => {
    if(window.location?.href?.split("?status=")[1]){
      setPesquisaStatus(window?.location?.href?.split("?status=")[1]);
    }

    if(timeToRefreshRequestList && timeToRefreshRequestList !== "0"){
      const refreshList = setInterval(() => {
        getRequests();
      }, parseInt(timeToRefreshRequestList) * 1000); 

      return () => clearInterval(refreshList);
    }
  }, []);

  useEffect(() => {
    return () => {
      if(cancelToken){
        cancelToken.cancel('Componente desmotando');
      }
    }
  }, [cancelToken]);

  useEffect(() => {
    searchWarehouse();
  }, [ , selectedWarehouse]);

  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />

      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <section className="content-header">
          <div className="title">
            <span>Requisição de Consumo</span>
          </div>
          <div className="content-header__items">
            {getPermission('OPERACOES - REQUISICOES - IMPORTACAO') && <button className="buttonInsert" style={{marginLeft: '0.5rem', backgroundColor: `${importCarrying ? '#001fff' : ''}`}}>
              <label htmlFor="file" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '0.15rem', color: 'white', fontWeight: 'inherit', fontSize: '0.9rem'}}>{importCarrying ? 'Importando...' : 'Importar'}</label>
              <input type="file" accept=".xlsx, .xls" style={{display: 'none'}} label="file" name="file" id="file" onChange={postExcel} placeholder="Importar" />
            </button>}
            <Link to="/product_requests/cadastrar">
              <button className="buttonInsert" style={{fontWeight: '400'}}>Cadastrar</button>
            </Link>
            <div className="content-header___selects">
              <select className='selectQtdeItens' value={qtdePage} onChange={ (e) => setQtdePage(e.target.value)}>
                <option value="50">Itens por página</option>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="40">40</option>
                <option value="50">50</option>
              </select>
              <select className='selectQtdeItens' value={typeSearch} onChange={(e) => setTypeSearch(e.target.value)}>
                <option value="">Requisição</option>
                <option value="Produto">Produto</option>
                <option value="Solicitante">Solicitante</option>
                <option value="Recebedor">Recebedor</option>
                <option value="Cliente">Cliente</option>
              </select>
              <Select options={warehouses} styles={selectStyle} id="lib-select" onChange={(e) => setSelectedWarehouse(e.value)} placeholder="Armazém" />
            </div>
            <input className="inputSearch" type="text" value={termSearch} onChange={(e) => setTermSearch(e.target.value)} placeholder="Search"/>
            <FaSearch className="iconSearch" style={{color: '#001675', height: "30px", width: "30px", paddingBottom: "1rem"}} />
          </div>
        </section>
          <div className="container">
            <table>
              <thead>
                <tr>
                  <th colSpan={1} style={{width: "15%"}}>#</th>
                  <th colSpan={1} style={{width: "25%"}}>
                    <StatusButton
                      showSelectStatus={showSelectStatus} 
                      setShowSelectStatus={setShowSelectStatus} 
                      listStatus={listStatus} 
                      setListStatus={setListStatus} 
                      selectedStatus={selectedStatus} 
                      setSelectedStatus={setSelectedStatus} 
                      setStatusButtonWasClicked={setStatusButtonWasClicked}
                    />
                  </th>
                  <th style={{width: "17.5%"}}>Cliente</th>
                  <th style={{width: "17.5%"}}>Data</th>
                  <th style={{width: "17.5%"}}>Hora</th>
                  <th style={{width: "17.5%"}}>Solicitante</th>
                  <th style={{width: "17.5%"}}>Aprovador</th>
                  <th style={{width: "17.5%"}}>Armazém</th>
                  <th style={{width: "17.5%"}}>Observação</th>
                  <th style={{width: "17.5%"}}>Recebedor</th>
                  <th style={{width: "17.5%"}}>Número Documento</th>
                  <th className='collumOption' style={{width: "17.5%"}}>Opções</th>
                </tr>
              </thead>
              <tbody>
                {list?.map((item, index)=>{
                  return(
                    <tr key={index}>
                      <td data-label="ID">{item.id}</td>
                      <td title={item.label_status} data-label="Status">{checkWhichIconMustToBeReturned(item.label_status, "2rem")}</td>
                      <td data-label="Cliente">{item.cliente}</td>
                      <td data-label="Data">{item.data}</td>
                      <td data-label="Hora">{item.hora}</td>
                      <td data-label="Solicitante">{item.user_create}</td>
                      <td data-label="Aprovador">{item.aprovador}</td>
                      <td data-label="Observação">{item.armazem}</td>
                      <td data-label="Observação">{item.observacao}</td>
                      <td data-label="Recebedor">{item.recebedor}</td>
                      <td data-label="Número Documento">{item.numero_documento}</td>
                      <td data-label="Opções">
                        {getPermission('OPERACOES - REQUISICOES - APROVACAO') && (parseInt(localStorage.getItem("usuario")) !== item.solicitante_id || getPermission("OPERACOES - REQUISICOES - SUPER APROVACAO")) && item.fluxo != '' && <Link className="action" onClick={() => openModalToEvaluate(item)} >
                          <FaCog color="#000" size={17} data-tip="Avaliar Solicitação"/>
                        </Link>}
                        <ReactTooltip />
                        {getPermission('OPERACOES - REQUISICOES - CADASTRO') && (parseInt(localStorage.getItem("usuario")) === item.solicitante_id || getPermission("OPERACOES - REQUISICOES - EDITA TERCEIROS")) && <Link className="action" to={`/product_requests/cadastrar/u${item.id}`} >
                          <FaPen color="#000" size={17} data-tip="Editar"/>
                        </Link>}
                        <ReactTooltip />
                          <Link className="action" to={`/product_requests/cadastrar/v${item.id}`} >
                            <FaEye color="#000" size={19} data-tip="Visualizar"/>
                          </Link>
                        <ReactTooltip />
                      </td> 
                    </tr>
                  )
                })}
                {list?.length == 0 && <tr>
                  <td colSpan={8}><label className='required'>Nenhum registro encontrado!</label></td>
                </tr>}
              </tbody>
            </table>
          </div>
          <br/>
          <TablePagination limitPage={limitPage} setLimitPage={setLimitPage} page={page} pesquisa_status={selectedStatus} qtdePage={qtdePage} setCarrying={setCarrying} setList={setList} setPage={setPage} setQtdePage={setQtdePage} setTotal={setTotal} termSearch={termSearch} API="/api/product_requests/getSearch" params={{}}/>
        </div>    
      }

      <ModalStatus modalStatus={modalStatus} setModalStatus={setModalStatus} newStatus={novo_status} setNewState={setNovoStatus} states={listChangeStatus} changeStatus={changeStatus} listItems={listItemsForApproval}></ModalStatus>
    </div>
  )
}